var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNetworkWeather = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.916 10.5H5.5a4 4 0 1 0 0 8H18a3.5 3.5 0 0 0 0-7h-1.6a5.002 5.002 0 0 0-9.484-1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.5 5.5a4 4 0 0 1 3.247 6.333A3.5 3.5 0 0 0 19 10.499h-1.6a5 5 0 0 0-2.225-3.223A4 4 0 0 1 18.5 5.5"
})));
export default SvgNetworkWeather;